import React, { useEffect, useState } from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoHeader from './Estacionamientos/EstacionamientoHeader'
import EstacionamientoService from "../services/EstacionamientoService";
import CiudadanosService from "../services/CiudadanosService";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Botonera from "./Estacionamientos/Botonera";
import BotoneraWithFooter from "./Estacionamientos/BotoneraWithFooter";
import { Modal, ModalBody, ModalHeader, Label, ModalFooter, Button, Spinner} from "reactstrap";
import EstacionamientoSmallHeader from "./Estacionamientos/EstacionamientoSmallHeader";
import bodySiteM from "./BodySiteM.module.css";


const EstacionamientoActivate = () => {
    const navigate = useNavigate();
    const [modalPop, setModalPop] = useState(true);
    const [availableCredit, setAvailableCredit] = useState("...");
    const [claveR, setClaveR] = useState({clave: ""});
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading ] = useState(false);
    

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setClaveR({
          ...claveR,
          [name]: value,
        });
      };
    
      const togglePop = () => {
        setModalPop(!modalPop);
    }

    const hideFooter = () => {
        document.getElementsByTagName("footer")[0].style.visibility='hidden'
        document.getElementById("miBotonera").style.visibility='hidden'
        
    }

      const showFooter = () => {
        document.getElementsByTagName("footer")[0].style.visibility='visible'
        document.getElementById("miBotonera").style.visibility='visible'

      }

    const cambioClave = () => {
        EstacionamientoService.cambioClave(localStorage.getItem("estacionamiento_celular"),
        claveR.clave, localStorage.getItem("estacionamiento_pass"), localStorage.getItem("estacionamiento_token"))
        .then((resp)=> {
            setLoading(false);
            navigate("/estacionamiento");
        })
        .catch((error) => 
        {   setErrorMessage(error.response.data.messageError);
            setLoading(false);
        }
         );
    }    
    
    const chequearCodigo = () => {
            EstacionamientoService.login(localStorage.getItem("estacionamiento_celular"), claveR.clave)
            //EstacionamientoService.login("1133844364", localStorage.getItem("estacionamiento_pass"))
            .then((resp)=>{
               
                localStorage.setItem("estacionamiento_token", resp.data.token);
                cambioClave();
                })
            .catch((error) => 
            {   setErrorMessage(error.response.data.messageError);
                setLoading(false);
            }
             );
             setLoading(true);
        }
    
    const validarCodigo = () => {
        if (claveR.clave=="")
            setErrorMessage("Se debe ingresar una clave para continuar");
        else
            chequearCodigo();

    }
        

    return (
        <>
       <div class="container text-center estacionamientoContent" >
       <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/")}}/>
       <EstacionamientoSmallHeader texto="" retorno="/"/>
       <Modal isOpen={modalPop} toggle={togglePop} modalClassName={bodySiteM.modalpos} contentClassName={bodySiteM.modalinfo}>
   
   {/*} <ModalHeader className={bodySiteM.modaltitle}>Informaci&oacute;n</ModalHeader>*/}
                <ModalBody className={bodySiteM.modalinfo}>
                  <div class="row">
                  <div class="col miniTextWhite">Para garantizar la seguridad de tu cuenta te enviamos por única vez a tu Whatsapp un código que será necesario para habilitar las funcionalidades del Estacionamiento Inteligente. Por favor ingresalo a continuación para activarlo</div>
                  </div>
                  
                </ModalBody>
                <ModalFooter>
                    
                        <div class="col alignCenter">
                    <Button  className={bodySiteM.buttonInvertedDangerMini} onClick={togglePop}>Ok</Button>
                    </div>
                    
                </ModalFooter>
                
                </Modal>
                <div class="row"><div class="col">&nbsp;</div></div>
            <div class="row">
        <div class="col miniTitle">Ingresa el c&oacute;digo recibido para activar</div></div>
        <div class="row">
        <div class="col miniTitle noMargin">tu cuenta</div></div>
       <div class="row">
          <div class="col">
                <input type="tel" maxLength="4" name="clave" 
                className="inputText inputBigWidth" placeholder="Codigo recibido por Whatsapp" value={claveR.clave} onChange={changeHandler}onFocus={hideFooter} onBlur={showFooter}></input>
                
          </div>
          </div>
            <div class="row">
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonEstacionamientoClip " onClick={validarCodigo}>Activar estacionamiento</button>
                    </div>
                </div>
            </div>
           
        </div>
        <p class="errorText" align="center">{errorMessage}</p>
        {loading ?  <div align="center">
   <Spinner color="primary" align="center"/></div>:<></>}
        <Botonera/>
        </>
    )
    ;
    }
export default EstacionamientoActivate;